/* eslint-disable import/no-cycle */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { shallowEqual, useSelector } from 'react-redux';
import Table, { TablePagination } from '../../molecules/table';
import Label from '../../atoms/label/label';
import Link, { LinkTheme } from '../../atoms/link/link';
import { IconType } from '../../atoms/icon/icon';
import { getLink } from '../../../routes/route';
import LoadFromCatalogButton from '../../molecules/loadFromCatalogButton/loadFromCatalogButton';
import { storeStructure } from '../../../store/reducers';
import FormValidation from '../../atoms/formEnums/formValidation';
import Button, { ButtonTheme, ButtonType } from '../../atoms/button/button';
import { composeURL } from '../../../utils/urlTools';
import swal from 'sweetalert';
import ButtonPopup from '../../atoms/buttonPopup/buttonPopup';
import FormInputTypes from '../../atoms/formEnums/formInputTypes';
import BulkImportTypes from '../../atoms/bulkImport/bulkImportTypes';
import { httpPost } from '../../../store/externalCalls/httpCalls';
import { useLocation, useNavigate } from 'react-router-dom';

const TableSection = (props) => {
  const {
    configFile,
    valuesPaginated,
    onClickCreate,
    onChangePage,
    onSearch,
    onSort,
    onChangeItem,
    onChangeRow,
    onChangeItemPosition,
    onClickRemoveItem,
    onOrderItems,
    onClickRow,
    onClickBulkDelete,
    onBulkAction,
    history,
    match,
    initDataSelected,
    customEditUrl,
    maxElementsSelectable,
    onSelectUrl,
  } = props;

  const location = useLocation();
  const currentPath = location.pathname;
  const navigate = useNavigate();
  const label = configFile?.label ? configFile?.label : '';
  const helpText = configFile?.helpText ? configFile?.helpText : '';
  const canOpen = configFile?.canOpen !== undefined ? configFile?.canOpen : true;
  const canOpenWhen = configFile?.canOpenWhen !== undefined ? configFile?.canOpenWhen : null;
  const canChangePosition = configFile?.canChangePosition !== undefined ? configFile?.canChangePosition : false;
  const sortingPositionIndex = canChangePosition === true ? configFile?.sortingPositionIndex : '';
  const canEdit = configFile?.canEdit !== undefined ? configFile?.canEdit : false;
  const canEditWhen = configFile?.canEditWhen !== undefined ? configFile?.canEditWhen : null;
  const canCreate = configFile?.canCreate !== undefined ? configFile?.canCreate : false;
  const canRemove = configFile?.canRemove !== undefined ? configFile?.canRemove : false;
  const canRemoveWhen = configFile?.canRemoveWhen !== undefined ? configFile?.canRemoveWhen : null;
  const canModify = configFile?.canModify !== undefined ? configFile?.canModify : false;
  const canModifyWhen = configFile?.canModifyWhen !== undefined ? configFile?.canModifyWhen : null;
  const isSelectable = configFile?.isSelectable !== undefined ? configFile?.isSelectable : false;
  const isMultiSelectable = configFile?.isMultiSelectable !== undefined ? configFile?.isMultiSelectable : false;
  const bulkSelectable = configFile?.bulkSelectable !== undefined ? configFile?.bulkSelectable : false;
  const bulkButtons = configFile?.bulkButtons !== undefined ? configFile?.bulkButtons : [];
  const { createButton, createButtonUrl } = configFile;
  const emptyMessage = configFile?.emptyButtonUrl !== undefined ? configFile?.emptyButtonUrl : null;
  const emptyButtonUrl = configFile?.canEditWhen !== undefined ? configFile?.canEditWhen : null;
  const emptyButton = configFile?.emptyButton !== undefined ? configFile?.emptyButton : null;
  const createPath = configFile?.createPath !== undefined ? getLink(configFile?.createPath, currentPath) : '';
  const refreshURL = configFile?.refreshURL !== undefined ? configFile?.refreshURL : '';
  const fromCatalogTable = configFile?.fromCatalogTable !== undefined ? configFile?.fromCatalogTable : undefined;
  const isDragable = configFile?.isDragable !== undefined ? configFile?.isDragable : false;
  const errorState = useSelector((state) => state[storeStructure.Errors]);
  const session = useSelector((state) => state[storeStructure.Session], shallowEqual);
  const [dataSel, setDataSel] = useState([]);
  const [valuesPaginatedState, setValuesPaginatedState] = useState(valuesPaginated);
  useEffect(() => {
    setDataSel(initDataSelected);
  }, [initDataSelected]);
  useEffect(() => {
    setValuesPaginatedState(valuesPaginated);
  }, [valuesPaginated]);
  const handleClickEdit = (row) => {
    let params = ["appId", "areaId", 'mainHubSlugName', 'spaceSlugName'];
    if (customEditUrl) {
      navigate(composeURL(session, params, customEditUrl, row.id), {
        state: {
          from: location.pathname,
        },
      });
      return;
    } else if (configFile?.customEditUrl) {
      const editId = row[configFile?.editId] ?? row.id;
      navigate(composeURL(session, params, configFile?.customEditUrl, editId), {
        state: {
          from: location.pathname,
        },
      });
      return;
    }
    if (configFile?.editURL !== undefined) {
      const editId = row[configFile?.editId] ?? row.id;
      const url = getLink(configFile?.editURL, currentPath);
      navigate(composeURL(session, params, url, editId), {
        state: {
          from: location.pathname,
        },
      });
      return;
    } else {
      // eslint-disable-next-line no-console
      console.error('You must to define a editURL attribute on configFile');
    }
  };
  const handleClickModify = (row) => {
    if (configFile?.editURL !== undefined) {
      navigate(getLink(configFile?.modifyURL, currentPath, row.id), {
        state: {
          from: location.pathname,
        },
      });
    } else {
      // eslint-disable-next-line no-console
      console.error('You must to define a editURL attribute on configFile');
    }
  };
  const handlerDragEnd = (result) => {
    const { source, destination } = result;
    const newValues = {
      ...valuesPaginatedState,
      data: [...valuesPaginatedState.data],
    };

    const [removed] = newValues.data.splice(source.index, 1);
    newValues.data.splice(destination.index, 0, removed);
    const sortMode = configFile?.orderIndex ?? 'asc';

    if (sortingPositionIndex !== '') {
      const pageOffset = valuesPaginatedState.perPage * (valuesPaginatedState.currentPage - 1);
      const total =
        typeof valuesPaginatedState.total === 'number'
          ? valuesPaginatedState.total
          : pageOffset + newValues.data.length;


      newValues.data = newValues.data.map((row, index) => {
        const newRow = { ...row };
        const globalIndexAsc = pageOffset + index;

        if (sortMode == 'desc') {
          newRow[sortingPositionIndex] = (total - 1) - globalIndexAsc;
        } else {
          newRow[sortingPositionIndex] = index
            + (valuesPaginatedState.perPage * (valuesPaginatedState.currentPage - 1));
        }

        return newRow;
      });
    }
    setValuesPaginatedState(newValues);
    onOrderItems(newValues.data, true);
  };
  const handlerBulkAction = (action, dataSelected, type) => {
    onBulkAction(action, dataSelected, type).then(() => {
      setDataSel([]);
    });
  }

  const handleRefresh = (refreshURL) => {
    httpPost(refreshURL).then((response) => console.log(response))
  }
  return (
    <div className="form-group" data-component="tableSectionv2">
      <div className={`row text-${errorState[configFile?.attributeName] !== undefined ? FormValidation.ERROR : FormValidation.PENDING}`}>
        <Label helpText={helpText}>
          {label}
        </Label>
      </div>
      {(errorState[configFile?.attributeName] !== undefined)
        && (
          <div className={`text-${errorState[configFile?.attributeName] !== undefined ? FormValidation.ERROR : FormValidation.PENDING}`}>
            <small className="form-text">{errorState[configFile?.attributeName]}</small>
          </div>
        )}
      {createPath !== ''
        && (
          <div>
            <Link
              id={`${configFile?.attributeName}-new`}
              icon={IconType.NEW}
              theme={LinkTheme.PRIMARY}
              to={createPath}
            >
              New
            </Link>
            {fromCatalogTable !== undefined
              && (
                <LoadFromCatalogButton
                  id={"fromCatalog"}
                  label={label}
                  configFile={fromCatalogTable}
                  fromCatalogText={(configFile?.fromCatalogText ? configFile?.fromCatalogText : null)}
                  multiple={configFile?.fromCatalogTableMultiple ?? false}
                />
              )}
            {configFile?.bulkDelete && dataSel.length > 0 &&
              <Button onClick={() => onClickBulkDelete(dataSel)} theme={ButtonTheme.ERROR}>{`Delete ${dataSel.length} item${dataSel.length != 1 ? 's' : ''}`}</Button>
            }
            {
              refreshURL !== ''
              && (
                <Button
                  id={`${configFile?.attributeName}-refresh`}
                  icon={IconType.SYNC}
                  theme={LinkTheme.INFO}
                  onClick={() => handleRefresh(refreshURL)}
                >
                  Refresh
                </Button>
              )
            }
          </div>
        )}

      <div className="table-responsive">
        {bulkSelectable && <div><div className="float-left">{dataSel.length} records selected</div>
          {bulkButtons && bulkButtons.map((but, index) => {
            let extraParams = [];
            if ((but.action == "bulkImport" || but.action == "bulkEdit") && but.sessionParams && but.sessionParams.length > 0) {
              but.sessionParams.map((ses) => {
                extraParams.push({
                  attributeName: ses,
                  type: FormInputTypes.TEXT_INPUT.TEXT,
                  required: true,
                  label: ses,
                  hidden: true,
                  defaultValue: session[ses]
                });
              });
            }
            if (but.action == "bulkEdit") {
              let found = extraParams.find((elem => elem.attributeName === "ids"));
              let ids = initDataSelected.map((el => el.id));
              extraParams.push({
                attributeName: "ids",
                type: FormInputTypes.TEXT_INPUT.TEXT,
                required: true,
                label: "ids",
                hidden: true,
                defaultValue: ids.join(",")
              });
            }

            return (
              <div key={index} className="mb-1 mx-1 float-right">
                {but.action == "bulkEdit" && initDataSelected.length > 0 &&
                  <ButtonPopup
                    id={"button-" + but.action}
                    buttonText={(!but.showNumberElems ? <span>{but.label}</span> : <span>{but.label} {dataSel.length} selected</span>)}
                    theme={(but.color ? but.color : ButtonTheme.PRIMARY)}
                    actionUrl={but.actionUrl}
                    reconfirmText={"Are you totally sure you want to do this action, There´s no turning back"}
                    refreshIfOk={true}
                    formConfig={
                      {
                        title: 'Massive edit',
                        description: <><div className="text-center">CAUTION! This Edit will update all records selected</div><br /><br /></>,
                        attributeName: 'newEdit',
                        fields: [
                          ...extraParams,
                          ...but.formConfig
                        ]
                      }
                    }
                  />
                }
                {but.action == "bulkImport" && initDataSelected.length == 0 &&
                  <ButtonPopup
                    id={"button-" + but.action}
                    buttonText={but.label}
                    theme={(but.color ? but.color : ButtonTheme.PRIMARY)}
                    actionUrl={but.actionUrl}
                    refreshIfOk={true}
                    formConfig={
                      {
                        title: 'Import from zip file',
                        description: 'Import from a zip file',
                        attributeName: 'newImport',
                        fields: [
                          ...extraParams,
                          {
                            attributeName: 'zipfile',
                            required: true,
                            type: FormInputTypes.DOWNLOADABLE,
                            label: 'Zip file',
                            helpText: 'Zip file to upload.',
                            fileType: ['.zip'],
                          },
                          ...but.formConfig
                        ]
                      }
                    }
                  />
                }
                {but.action != "bulkImport" && but.action != "bulkEdit" &&
                  but.hidden == "no-selection" && initDataSelected.length != 0 && <Button
                    id={"button-" + but.action}
                    type={ButtonType.BUTTON}
                    onClick={() => { handlerBulkAction(but.action, dataSel, but.type) }}
                    theme={(but.color ? but.color : ButtonTheme.PRIMARY)}
                    disabled={(but.disabled == "no-selection" && dataSel.length == 0)}
                    title={(but.title ? but.title : '')}
                  >
                    {!but.showNumberElems && <span>{but.label} </span>}
                    {but.showNumberElems && <span>{but.label} {dataSel.length} selected</span>}
                  </Button>
                }
              </div>);
          })}
        </div>
        }
        <Table
          id={configFile?.attributeName}
          dataSet={valuesPaginatedState.data}
          columnSet={configFile?.fields}
          label={label}
          canEdit={canEdit}
          canEditWhen={canEditWhen}
          permissionToUpdate={configFile?.permissionToUpdate}
          canRemove={canRemove}
          canRemoveWhen={canRemoveWhen}
          permissionToRemove={configFile?.permissionToRemove}
          canModify={canModify}
          canModifyWhen={canModifyWhen}
          onChange={onChangeItem}
          onChangeRow={onChangeRow}
          onChangePosition={onChangeItemPosition}
          canOpen={canOpen}
          canOpenWhen={canOpenWhen}
          canChangePosition={canChangePosition}
          sortingPositionIndex={sortingPositionIndex}
          canCreate={canCreate}
          permissionToCreate={configFile?.permissionToCreate}
          onClickEdit={handleClickEdit}
          onClickModify={handleClickModify}
          onClickCreate={onClickCreate}
          onClickRemove={onClickRemoveItem}
          onDragEnd={handlerDragEnd}
          isDragable={isDragable}
          emptyMessage={emptyMessage}
          emptyButtonUrl={emptyButtonUrl}
          emptyButton={emptyButton}
          createButton={createButton}
          createButtonUrl={createButtonUrl}
          isSelectable={isSelectable}
          isMultiSelectable={isMultiSelectable}
          bulkSelectable={bulkSelectable}
          maxElementsSelectable={maxElementsSelectable}
          onSelectUrl={onSelectUrl}
          onClickRow={onClickRow}
          initDataSelected={dataSel}
          onSearch={onSearch}
          onSort={onSort}
        />
        <TablePagination
          tableId={configFile?.attributeName}
          currentPage={valuesPaginatedState.currentPage}
          firstPageUrl={valuesPaginatedState.firstPageUrl}
          from={valuesPaginatedState.from}
          lastPage={valuesPaginatedState.lastPage}
          lastPageUrl={valuesPaginatedState.lastPageUrl}
          nextPageUrl={valuesPaginatedState.nextPageUrl}
          path={valuesPaginatedState.path}
          perPage={valuesPaginatedState.perPage}
          prevPageUrl={valuesPaginatedState.prevPageUrl}
          to={valuesPaginatedState.to}
          total={valuesPaginatedState.total}
          onChangePage={onChangePage}
        />
      </div>
    </div>
  );
};

TableSection.propTypes = {
  /**
   * Text to help the user. It is added to the Help Button atom.
   */
  helpText: PropTypes.string,
  /**
   * Text of new item buttom
   */
  createText: PropTypes.string,
  /**
   * Confinguration file to create a table
   */
  configFile: PropTypes.shape({}).isRequired,
  /**
   * Data table set loading from redux
   */
  valuesPaginated: PropTypes.shape({}),
  /**
   * Event when the user click on next or prev page of table pagination
   */
  onChangePage: PropTypes.func,
  onSearch: PropTypes.func,
  onSort: PropTypes.func,
  onClickCreate: PropTypes.func,
  onChangeItem: PropTypes.func,
  onClickRemoveItem: PropTypes.func,
  onOrderItems: PropTypes.func,
  onClickRow: PropTypes.func,
  onChangeItemPosition: PropTypes.func,
  onClickBulkDelete: PropTypes.func,
  initDataSelected: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({})), PropTypes.object]),
  customEditUrl: PropTypes.string,
  maxElementsSelectable: PropTypes.number,
  onSelectUrl: PropTypes.string,
};

TableSection.defaultProps = {
  helpText: '',
  createText: 'New Item',
  valuesPaginated: {},
  onChangePage: () => { },
  onSearch: () => { },
  onSort: () => { },
  onClickCreate: () => { },
  onChangeItem: () => { },
  onClickRemoveItem: () => { },
  onOrderItems: () => { },
  onClickRow: () => { },
  onChangeItemPosition: () => { },
  onClickBulkDelete: () => { },
  initDataSelected: [],
  customEditUrl: null,
  maxElementsSelectable: null,
};

export default TableSection;
